export default __webpack_public_path__ + "assets/919c42.svg";